import React from 'react';
import { getBreakpoints, useBreakpoint } from '@noths/polaris-client-ribbons-base';
export var Responsive = function Responsive(_ref) {
  var children = _ref.children,
    maxBreakpoint = _ref.maxBreakpoint,
    minBreakpoint = _ref.minBreakpoint;
  var breakpoint = useBreakpoint({
    initializeWithLarge: true
  });
  var breakpoints = getBreakpoints({
    minBreakpoint,
    maxBreakpoint
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, breakpoints.includes(breakpoint) && children);
};